export default __webpack_public_path__ + "static/2-9786e13e7acd5361754083e6ce8fa115.webp";